/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { Agent } from "./Agent";
import { Pagination } from "../../commons/types/Pagination";
export const ListAgentsResponse = core.serialization.object({
    data: core.serialization.list(Agent).optional(),
    pagination: Pagination.optional(),
});
